module.exports = __webpack_public_path__ + "static/media/usa-anli1.2a69def5.jpg";